import React, { useCallback, useEffect, useState } from 'react';

import { myInvoiceIcon } from '@europrocurement/l2d-icons';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { mediaObjectFiltersToElasticQuery, useAchatsService } from '@europrocurement/l2d-domain';
import WidgetWithAction from './components/WidgetWithAction';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';

// interne

const MesFacturesATraiter: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const kc = UseKeycloakService();
    const { mediaObjectApi } = useAchatsService();

    const [countOfMyUnregisteredInvoices, setCountOfMyUnregisteredInvoices] = useState<string>();

    useEffect(() => {
        mediaObjectApi
            .listMediaObjectMediaObjectCollection(
                mediaObjectFiltersToElasticQuery({
                    search: '',
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        createdBy: kc.getEmail(),
                        forceInterne: true,
                        dateDebutTraitementBefore: new Date(new Date().getTime() - 2 * 60 * 1000),
                        available: true,
                        deleted: false,
                    },
                    orders: [],
                    xIdSociete: 12,
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfMyUnregisteredInvoices(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [kc, mediaObjectApi]);

    const actionCallback = useCallback(async () => {
        navigate(achatsViewPathResolver('listmediaobjectinternally'));
    }, [navigate]);

    return (
        <Grid
            sx={{
                flex: 1,
            }}
            item
            lg={1}
            md={1}
            xs={12}
        >
            <WidgetWithAction
                title="Mes factures à traiter"
                icon={myInvoiceIcon}
                actionMessage="Traiter"
                actionCallback={actionCallback}
                data={countOfMyUnregisteredInvoices}
                paragraph="Mes factures à traiter :"
                color="blueGrey"
            />
        </Grid>
    );
};

export default MesFacturesATraiter;
